// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"7":"fd8d7e8f","35":"0f1b64a2","71":"b2e1a5d5","165":"d833e3df","207":"58832c94","393":"206bdc4e","453":"3c2e69a1","511":"bd15fb53","549":"667e63fa","562":"2ce138ec","728":"865eee98","838":"aacee9a4","852":"2135d2ce","962":"09c23ff0","999":"1df78ac2"}[chunkId] + ".js";
};